<template lang="pug">
  v-row(justify='center')
    v-dialog(
      v-model='openModal' 
      persistent='' 
      max-width='650'
    )
      v-form(
        ref="form" 
        v-model="valid" 
        lazy-validation
      ) 
      v-card(style="padding:10px")
        v-card-title(style="background-color:#F3F4F6;margin:-10px -10px 0 -10px")
          span(style="margin-left:-10px;margin-bottom:10px") Edit Tindakan 
        v-card-text           
          v-layout(row wrap)              
              v-flex(xs7 sm12 style="margin-top:20px")
                  span Nama Tindakan
                  v-textarea(
                    style="margin-top:10px" 
                    v-model="dataTindakan.titleTindakan" 
                    filled
                    disabled
                    rows="2"
                  )
              v-flex(xs7 sm12 style="margin-top:-20px")
                  span Oleh
                  v-text-field(
                    style="margin-top:10px" 
                    v-model="dataTindakan.penanggungJawab.name" 
                    disabled
                    filled
                  )
              v-flex(xs7 sm12 style="margin-top:-20px")
                  span Tanggal 
                  v-text-field(
                    v-model="dataTindakan.deadline"
                    prepend-inner-icon="event"
                    style="margin-top:10px"
                    disabled
                    filled
                  )
              v-flex(xs7 sm12 style="margin-top:-20px")
                  span Status
                  v-select(
                    style="margin-top:10px"  
                    :items='statusOptions' 
                    v-model="dataTindakan.statusTindakan" 
                    label="Pilih" 
                    single-line 
                    outlined
                  ) 

              v-flex(xs7 sm12 style="margin-top:-20px")
                  span Catatan
                  v-textarea(
                    style="margin-top:10px" 
                    v-model="dataTindakan.description" 
                    rows="2"
                    outlined
                  )

              v-flex(xs7 sm12 style="margin-top:-20px")
                  span Lampiran
                  div(
                    style="margin-top:10px"
                    class="attachment" 
                    v-if="!dataTindakan.lampiranUploadId && ( !docLampiran || docLampiran.size > 10000000 )"
                  )
                      v-file-input(
                        prepend-icon="" 
                        prepend-inner-icon="mdi-plus" 
                        :rules="rules"  
                        label="Lampiran" 
                        v-model="docLampiran" 
                        single-line outlined
                      )
                          template(
                            v-slot:selection="{ text }" 
                          )
                              v-chip(
                                small 
                                label 
                                color="primary"
                              ) {{ text }}
                  v-flex(
                    class="attachmentName" 
                    v-else
                  )
                      span {{ getNameFile() }}
                      v-btn(
                        icon 
                        color="red" 
                        @click="deleteDocLampiran('docPendukung')"
                      )
                          v-icon mdi-close
                  

        v-card-actions(style="margin-top:10px")
          v-spacer
          v-btn(
            large 
            depressed
            class="elevation-0 pl-6 pr-6 mr-2"
            @click='handleClose()'
          ) CLOSE
          v-btn(
            color="primary"
            large 
            depressed
            class="elevation-0 pl-6 pr-6"
            @click='actionSave'
            :disabled="!isFormValid"
          ) Update
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
export default {
  name: "EditTindakanClosing",
  data () {
      return {
        valid: true,
        startMenu: false,
        docLampiran:null,
        statusOptions :["OPEN", "CONTINUE","CLOSE"],
        rules: [
          value => !value || value.size < 10000000 || 'Ukuran file harus dibawah 10 MB!',
        ],
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        openModal: false,
        dataTindakan : {
          titleTindakan:"",
          penanggungJawab: {},
          statusTindakan:"OPEN",
          deadline:"",
          lampiranUploadId:null,
          lampiran: {
            docPendukung: ""
          },
          description: ""
        },
        oldVal : {
          titleTindakan:"",
          penanggungJawab: {},
          statusTindakan:"OPEN",
          deadline:"",
          lampiranUploadId:null,
          lampiran: {
            docPendukung: ""
          },
          description: ""
        },
      }
    },
  computed: {
    ...mapState(["API_URL"]),
    isFormValid() {
      return (
        this.dataTindakan.statusTindakan == 'CLOSE'
        && this.dataTindakan.description
        && this.dataTindakan.lampiranUploadId
      )
    }
  },
  methods: {
    async handleClose(){
      if ( this.oldVal.lampiranUploadId != this.dataTindakan.lampiranUploadId && this.dataTindakan.lampiranUploadId ) {
        await this.deleteDocLampiran('docPendukung')
      }

      if ( !this.dataTindakan.lampiranUploadId ) {
        this.oldVal.lampiranUploadId = "" 
        this.oldVal.lampiran = {}
      }

      this.dataTindakan.statusTindakan = this.oldVal.statusTindakan
      this.dataTindakan.description = this.oldVal.description
      this.openModal = false
    },
    clearDate() {
      this.startMenu = false;
    },
    docName(name){
        return this.$setFilename(name);
      },
    async deleteDocLampiran(name){
        let id = this.dataTindakan.lampiranUploadId;      
        this.$store
          .dispatch("deleteFile", {
              uploadId: id,
              folderName: name,
          })
          .then(() => {
              this.docLampiran = null;
              this.dataTindakan.lampiranUploadId =  ""
              this.dataTindakan.lampiran = {}
          })
          .catch(() => {
              this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
          });
      },
    actionSave(){
      this.$refs.form.validate();
      if(this.$refs.form.validate() === true) {
        this.openModal = false
        this.docLampiran = null
      }
    },
    showModal(val) {
      this.dataTindakan = val
      this.oldVal = JSON.parse(JSON.stringify(val));
      this.openModal = true
    },
    getNameFile() {
      if ( this.docLampiran ) {
        return this.docLampiran.name
      } else {
        return this.docName(this.dataTindakan.lampiran.docPendukung)
      }
    }
  },
  watch :{
    docLampiran(params){
      if(params && params.size < 10000000){
        let formData = new FormData();
        formData.append('uploadId', Date.now() );
        formData.append('docPendukung', params );
        axios.post(`${this.API_URL}/v1/requests/attachment/docPendukung`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}})
        .then(res =>{
           this.dataTindakan.lampiranUploadId =  res.data.uploadId
           this.dataTindakan.lampiran.docPendukung = res.data.file.filename
        })
      }
    },
  }
}
</script>

<style>

</style>